// export const DEFAULT_TIMEOUT = 30000; // 30 seconds
export const DEFAULT_TIMEOUT = 300000; // 5 minutes

export const MICRO_SERVICE_ROUTES = {
	NOTIFICATIONS: "/notifications",
	USERS: "/users",
	INSTITUTES: "/institutes",
	CERTIFICATES: "/certificates",
	MEMBERS: "/members",
};
export const API_ROUTES = {
	AUTH: `${MICRO_SERVICE_ROUTES.USERS}/auth/v1`,
	EQUIPMENTS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/equipment`,
	LABS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/labs`,
	USERS: `${MICRO_SERVICE_ROUTES.USERS}/users/v1`,
	NOTIFICATIONS: `${MICRO_SERVICE_ROUTES.NOTIFICATIONS}/notifications`,
	CERTIFICATES: `${MICRO_SERVICE_ROUTES.CERTIFICATES}/certificates`,
	MEMBERS: `${MICRO_SERVICE_ROUTES.MEMBERS}/members`,
} as const;

export const API_PATHS = {
	AUTH: {
		SIGN_IN: "/organization/login",
		SIGN_UP: "/email/register",
		VERIFY_EMAIL: "/verify-email",
		FORGOT_PASSWORD: "/forgot-password",
		RESET_PASSWORD: "/reset-password",
		VERIFY_OTP: "/verify-otp",
		RESEND_OTP: "/resend-otp",
	},
	USER: {
		GET_PROFILE: "/profile",
		PROFILE_IMAGE_UPLOAD_URL: "/profile/image/upload-url",
		PROFILE_IMAGE_UPDATE: "/profile/image",
		COMMITTE_MEMBERS: "/committee-members",
		COMMITTE_MEMBERS_BULK: "/committee-members/bulk",
		COMMITTEE_MEMBER_DETAILS: (uuid: string) => `/committee-members/${uuid}`,
		ACTIVATE_MEMBER: (uuid: string) => `/${uuid}/activate`,
		DEACTIVATE_MEMBER: (uuid: string) => `/${uuid}/deactivate`,
		USER_ROLES: "/user-role",
		ROLES: "/roles",
		ADMIN_USERS: "/users/v1/admin-users",
	},

	INSTITIUTE: {
		FILE_UPLOAD_URL: "/attachments/upload",
		TECHNOLOGY: "/technology",
		MEMBER_TYPES: "/memberType",
		DESIGNATION: "/designation",
		QUALIFICATION: "/qualification",
		ORGANIZATION_TYPE: "/organization-type",
		TECH_QUALIFICATION: "/tech-qualification",
		PROVINCE: "/province",
		GET_DIVISION_BY_PROVINCE: "/division/province",
		GET_DISTRICTS_BY_DIVISION: "/district/division",
		GET_TEHSILS_BY_DISTRICT: "/tehsil/district",
		GET_CITIES_BY_DISTRICT: "/city/district",
		GET_ALL_UC: "/union-council",
		COURSE_STREAM: "/course-stream",
		COURSE_LEVEL: "/course-level",
		COURSE_NOTIFYING_AUTHORITY: "/course-notifying-authority",
		COURSES: "/course",
		COURSE_DETAILS: (uuid: string) => `/course/${uuid}`,
		SECTOR: "/sector",
		PRIORITY: "/priority",
		EVENT_TYPE: "/event-type",
		APPLIES_TO: "/applies-to",
		APPLICATIONS_PENDING: "/applications/admin/pending",
		APPLICATIONS_SCRUTINIZED: "/applications/admin/scrutinized",
		APPLICATIONS_INSPECTED: "/applications/inspected",
		APPLICATIONS_REJECTED: "/applications/admin/rejected",
		APPLICATIONS_APPROVED: "/applications/admin/approved",
		DASHBOARD_STATS: "/dashboard/stats",
		DASHBOARD_PIE_STATS: "/dashboard/pie-stats",
		DASHBOARD_BAR_STATS: "/dashboard/bar-stats",
		APPLICATION_PREDICTION: (applicationId: string) => `/applications/${applicationId}/prediction`,
	},

	NOTIFICATIONS: {
		READ: "/read",
		STREAM: "/user/{id}/stream",
	},
	CERTIFICATES: {
		GET_DETAILS: "/details",
		DOWNLOAD: "/download",
	},
};

const ACTIONS = {
	REJECT: "reject",
};

export const SERVER_ROUTES = {
	AUTH: {
		SIGN_IN: API_ROUTES?.AUTH + API_PATHS?.AUTH?.SIGN_IN,
		SIGN_UP: API_ROUTES?.AUTH + API_PATHS?.AUTH?.SIGN_UP,
		VERIFY_EMAIL: API_ROUTES.AUTH + API_PATHS.AUTH.VERIFY_EMAIL,
		FORGOT_PASSWORD: API_ROUTES.AUTH + API_PATHS.AUTH.FORGOT_PASSWORD,
		RESET_PASSWORD: API_ROUTES.AUTH + API_PATHS.AUTH.RESET_PASSWORD,
		VERIFY_OTP: API_ROUTES.AUTH + API_PATHS.AUTH.VERIFY_OTP,
		RESEND_OTP: API_ROUTES.AUTH + API_PATHS.AUTH.RESEND_OTP,
	},
	USER: {
		GET_PROFILE: API_ROUTES.AUTH + API_PATHS.USER.GET_PROFILE,
		PROFILE_IMAGE_UPLOAD_URL: API_ROUTES.USERS + API_PATHS.USER.PROFILE_IMAGE_UPLOAD_URL,
		PROFILE_IMAGE_UPDATE: API_ROUTES.USERS + API_PATHS.USER.PROFILE_IMAGE_UPDATE,
		PROFILE_UPDATE: API_ROUTES.USERS + API_PATHS.USER.GET_PROFILE,
		COMMITTE_MEMBERS: API_ROUTES.USERS + API_PATHS.USER.COMMITTE_MEMBERS,
		COMMITTE_MEMBERS_BULK: API_ROUTES.USERS + API_PATHS.USER.COMMITTE_MEMBERS_BULK,
		COMMITTEE_MEMBER_DETAILS: (uuid: string) => API_ROUTES.USERS + API_PATHS.USER.COMMITTEE_MEMBER_DETAILS(uuid),
		ACTIVATE_MEMBER: (uuid: string) => API_ROUTES.USERS + API_PATHS.USER.ACTIVATE_MEMBER(uuid),
		DEACTIVATE_MEMBER: (uuid: string) => API_ROUTES.USERS + API_PATHS.USER.DEACTIVATE_MEMBER(uuid),
		USERS_ROLES: `${MICRO_SERVICE_ROUTES.USERS}${API_PATHS.USER.USER_ROLES}`,
		ADMIN_USERS: `${MICRO_SERVICE_ROUTES.USERS}${API_PATHS.USER.ADMIN_USERS}`,
	},

	NOTIFICATIONS: {
		NOTIFICATIONS: API_ROUTES.NOTIFICATIONS,
		READ: (id: string) => `${API_ROUTES.NOTIFICATIONS}/${id}${API_PATHS.NOTIFICATIONS.READ}`,
		STREAM: (id: string) => `${API_ROUTES.NOTIFICATIONS}${API_PATHS.NOTIFICATIONS.STREAM.replace("{id}", id)}`,
	},
	EQUIPMENTS: {
		GET: (limit: number, page: number) => `${API_ROUTES.EQUIPMENTS}?limit=${limit}&page=${page}`,
		CREATE: API_ROUTES.EQUIPMENTS,
		UPDATE: (id: string) => `${API_ROUTES.EQUIPMENTS}/${id}`,
		DELETE: (id: string) => `${API_ROUTES.EQUIPMENTS}/${id}`,
	},
	LABS: {
		GET: (limit: number, page: number) => `${API_ROUTES.LABS}?limit=${limit}&page=${page}`,
		CREATE: API_ROUTES.LABS,
		UPDATE: (uuid: string) => `${API_ROUTES.LABS}/${uuid}`,
		DELETE: (uuid: string) => `${API_ROUTES.LABS}/${uuid}`,
	},
	INSTITUTE: {
		ATTACHMENT_UPLOAD: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.FILE_UPLOAD_URL,
		APPLICATIONS_REJECTED: (applicationId: number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/applications/${applicationId}/${ACTIONS.REJECT}`,
		GET_INSTITUTES: MICRO_SERVICE_ROUTES.INSTITUTES + "/institutes",
		GET_APPLICATION_DETAILS: (applicationId: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/applications/${applicationId}`,
		SUBMIT_APPLICATION_SCRUTINY: (id: number) => MICRO_SERVICE_ROUTES.INSTITUTES + `/applications/${id}/scrutinize`,
		ISSUE_CERTIFICATE: (id: string) => MICRO_SERVICE_ROUTES.INSTITUTES + `/applications/${id}/issue-certificate`,
		SUBMIT_APPLICATION_COMMITTEE: MICRO_SERVICE_ROUTES.INSTITUTES + "/application-committee",
		GET_COMMITTEE_DETAILS: (committeeId: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/application-committee/committee-approval-pending/${committeeId}`,
		GET_APPLICATION_COMMITTEE: (committeeId: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/application-committee/${committeeId}`,
		APPROVE_COMMITTEE: (committeeId: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/application-committee/${committeeId}/approve`,
		REJECT_COMMITTEE: (committeeId: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/application-committee/${committeeId}/reject`,
		FINALIZE_COMMITTEE: (committeeId: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/application-committee/${committeeId}/finalize`,
		GET_INSTITUTE_DETAILS: (instituteId: string) => `${MICRO_SERVICE_ROUTES.INSTITUTES}/institutes/${instituteId}`,
		GET_INSPECTION_TYPE: MICRO_SERVICE_ROUTES.INSTITUTES + "/inspection-types",
		GET_ALL_TECHNOLOGIES: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.TECHNOLOGY,
		GET_MEMBER_TYPES: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.MEMBER_TYPES,
		GET_ALL_DESIGNATIONS: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.DESIGNATION,
		GET_HEIGHST_QUALIFICATION: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.QUALIFICATION,
		GET_ORGANIZATION_TYPE: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.ORGANIZATION_TYPE,
		GET_TECH_QUALIFICATION: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.TECH_QUALIFICATION,
		GET_ALL_PROVICE: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.PROVINCE,
		GET_ALL_DIVISIONS_BY_PROVINCE: (id: string | number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}` + `${API_PATHS.INSTITIUTE.GET_DIVISION_BY_PROVINCE}/${id}/divisions`,
		GET_ALL_DISTRICTS_BY_DIVISION: (id: string | number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}` + `${API_PATHS.INSTITIUTE.GET_DISTRICTS_BY_DIVISION}/${id}/districts`,
		GET_ALL_TEHSILS_BY_DISTRICT: (id: string | number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}` + `${API_PATHS.INSTITIUTE.GET_TEHSILS_BY_DISTRICT}/${id}/tehsils`,
		GET_ALL_CITIES_BY_DISTRICT: (id: string | number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}` + `${API_PATHS.INSTITIUTE.GET_CITIES_BY_DISTRICT}/${id}/cities`,
		GET_ALL_UC: `${MICRO_SERVICE_ROUTES.INSTITUTES}` + `${API_PATHS.INSTITIUTE.GET_ALL_UC}`,
		GET_COURSE_STREAM: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.COURSE_STREAM,
		GET_COURSE_LEVEL: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.COURSE_LEVEL,
		GET_COURSE_NOTIFYING_AUTHORITY: (limit: number, page: number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.COURSE_NOTIFYING_AUTHORITY}?limit=${limit}&page=${page}`,
		CREATE_COURSE: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.COURSES,
		GET_COURSES: (limit: number, page: number, search?: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.COURSES}?limit=${limit}&page=${page}${
				search ? `&search=${encodeURIComponent(search)}` : ""
			}`,
		GET_COURSE_DETAILS: (uuid: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.COURSE_DETAILS(uuid)}`,
		GET_SECTOR: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.SECTOR,
		GET_APPLICATIONS_PENDING: `${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.APPLICATIONS_PENDING}?`,

		GET_APPLICATIONS_SCRUTINIZED: `${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.APPLICATIONS_SCRUTINIZED}?`,
		GET_APPLICATIONS_INSPECTED: `${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.APPLICATIONS_INSPECTED}?`,
		GET_APPLICATIONS_REJECTED: `${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.APPLICATIONS_REJECTED}?`,
		GET_APPLICATIONS_APPROVED: `${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.APPLICATIONS_APPROVED}?`,
		GET_COMMITTEE_APPROVAL_PENDING: `${MICRO_SERVICE_ROUTES.INSTITUTES}/application-committee/committee-approval-pending?`,
		GET_COMMITTEE_APPROVED: `${MICRO_SERVICE_ROUTES.INSTITUTES}/application-committee/approved?`,
		GET_COMMITTEE_REJECTED: `${MICRO_SERVICE_ROUTES.INSTITUTES}/application-committee/rejected?`,
		GET_DASHBOARD_STATS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/dashboard/stats`,
		GET_ORGANIZATION_STATS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/organization/stats`,
		GET_DASHBOARD_PIE_STATS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/dashboard/pie-stats`,
		GET_DASHBOARD_BAR_STATS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/dashboard/bar-stats`,
		GET_COMMITTEE_FINALIZED: `${MICRO_SERVICE_ROUTES.INSTITUTES}/application-committee/finalized?`,
		GET_ATTACHMENT_URL: (key: string) => `${MICRO_SERVICE_ROUTES.INSTITUTES}/attachments/${key}`,
		GET_APPLICATION_PREDICTION: (applicationId: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.APPLICATION_PREDICTION(applicationId)}`,
		GET_COMMITTEE_MEMBERS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/applications`,
		GET_ACADEMIC_CALENDARS: (page: number, limit: number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/academic-calendars?page=${page}&limit=${limit}`,
		GET_PRIORITIES: (page: number, limit: number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/priority?page=${page}&limit=${limit}`,
		GET_EVENT_TYPES: (page: number, limit: number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/event-type?page=${page}&limit=${limit}`,
		GET_APPLIES_TO: (page: number, limit: number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/applies-to?page=${page}&limit=${limit}`,
		GET_CALENDAR_EVENTS: (academicCalendarId: string, page: number, limit: number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/academic-calendar-events?page=${page}&limit=${limit}&academicCalendarId=${academicCalendarId}`,
		CREATE_CALENDAR_EVENT: `${MICRO_SERVICE_ROUTES.INSTITUTES}/academic-calendar-events`,
		GET_CALENDAR_EVENT_DETAILS: (eventId: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/academic-calendar-events/${eventId}`,
		UPDATE_CALENDAR_EVENT: (eventId: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/academic-calendar-events/${eventId}`,
		CREATE_ACADEMIC_CALENDAR: `${MICRO_SERVICE_ROUTES.INSTITUTES}/academic-calendars`,
		UPDATE_ACADEMIC_CALENDAR_STATUS: (calendarId: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/academic-calendars/${calendarId}`,
		GET_CERTIFIED_INSTITUTES: `${MICRO_SERVICE_ROUTES.INSTITUTES}/institutes/certified`,
		GET_ALL_TRADES: `${MICRO_SERVICE_ROUTES.INSTITUTES}/courses`,
		GET_INSTITUTE_COURSES: (instituteId: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/institutes/${instituteId}/courses`,
		GET_APPLICATION_SESSIONS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/system/filters/application-sessions`,
		GET_APPLICATION_TYPES: `${MICRO_SERVICE_ROUTES.INSTITUTES}/applications/types`,
		GET_TERMS: (page: number, limit: number) => `${MICRO_SERVICE_ROUTES.INSTITUTES}/terms?page=${page}&limit=${limit}`,
		GET_SHIFTS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/shift`,
		GET_ASSESSMENT_BODIES: `${MICRO_SERVICE_ROUTES.INSTITUTES}/assessment-body`,
		GET_TEACHING_MODES: (page: number, limit: number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/teaching-mode?page=${page}&limit=${limit}`,
		GET_FEE_MODES: (page: number, limit: number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/fee-mode?page=${page}&limit=${limit}`,
		CREATE_TRADE_SESSION: `${MICRO_SERVICE_ROUTES.INSTITUTES}/trade-session`,
		GET_TRADE_SESSIONS: (page: number, limit: number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/trade-session?page=${page}&limit=${limit}`,
		DELETE_TRADE_SESSION: (sessionUuid: string) => `${MICRO_SERVICE_ROUTES.INSTITUTES}/trade-session/${sessionUuid}`,
		GET_SESSION_STATUSES: `${MICRO_SERVICE_ROUTES.INSTITUTES}/trade-session/session-statuses`,
		GET_REPORTS_OVERVIEW_STATS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/overview-stats`,
		GET_REPORTS_ATTENDANCE_STATS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/attendance-stats`,
		GET_REPORTS_GENDER_DISTRIBUTION: `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/gender-distribution`,
		GET_REPORTS_TRADE_WISE_COMPARISON: (page: number, limit: number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/trade-wise-comparison?page=${page}&limit=${limit}`,
		GET_REPORTS_ENROLLMENT_TRENDS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/enrollment-trends`,
		GET_REPORTS_DAILY_ATTENDANCE_TREND: `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/daily-attendance-trend`,
		GET_REPORTS_KPI_STATS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/kpi-stats`,
		GET_REPORTS_KPI_PERFORMANCE: (page: number, limit: number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/kpi-performance?page=${page}&limit=${limit}`,
		GET_REPORTS_ANALYTIC_STATS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/analytic-stats`,
		GET_REPORTS_SECTORWISE_JOB_PLACEMENT: `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/sectorwise-job-placement`,
		GET_REPORTS_TRADE_WISE_APPLICATION: (page: number, limit: number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/trade-wise-application?page=${page}&limit=${limit}`,
		GET_REPORTS_PROJECT_PERFORMANCE: `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/project-performance`,
		GET_REPORTS_RISK_ASSESSMENT: `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/risk-assessment`,
		GET_REPORTS_COMPONENT_PROGRESS: (page: number, limit: number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/component-progress?page=${page}&limit=${limit}`,
	},
	CERTIFICATES: {
		GET_CERTIFICATES: (page: number, limit: number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/applications/admin/certified?page=${page}&limit=${limit}`,
		GET_DETAILS: (instituteId: string) =>
			`${API_ROUTES.CERTIFICATES}/${instituteId}${API_PATHS.CERTIFICATES.GET_DETAILS}`,
		DOWNLOAD: (certificateId: string) =>
			`${API_ROUTES.CERTIFICATES}/${certificateId}${API_PATHS.CERTIFICATES.DOWNLOAD}`,
	},
	MEMBERS: {
		GET_DETAILS: (memberId: string) => `${API_ROUTES.MEMBERS}/${memberId}/details`,
		TOGGLE_STATUS: (memberId: string) => `${API_ROUTES.MEMBERS}/${memberId}/status`,
	},
	ATTENDANCE: {
		GET_ATTENDANCE: (tab: string) => `${MICRO_SERVICE_ROUTES.INSTITUTES}/attendance/${tab}`,
		UPDATE_ATTENDANCE: `${MICRO_SERVICE_ROUTES.INSTITUTES}/attendance`,
	},
} as const;

export const QUERY_KEYS = {
	USER: {
		PROFILE_IMAGE_UPDATE: "profile-image-update",
		PROFILE_UPDATE: "profile-update",
		GET_PROFILE: "profile",
		COMMITTE_MEMBERS: "committee-members",
		MEMBERS: "members",
		USER_ROLES: "user-roles",
		ROLES: "roles",
		USERS: "users",
	},
	INSTITUTES: {
		INSTITUTES: "institutes",
		INSTITUTE_DETAILS: "institute-details",
		APPLICATION_DETAILS: "application-details",
		COMMITTEE_DETAILS: "committee-details",
		EQUIPMENTS: "equipment",
		LABS: "labs",
		MEMBER_TYPE: "member-type",
		TECHNOLOGIES: "technologies",
		DESIGNATIONS: "designations",
		QUALIFICATIONS: "qualifications",
		TECH_QUALIFICATIONS: "tech-qualifications",
		PROVINCES: "provinces",
		DIVISIONS: "divisions",
		DISTRICTS: "districts",
		TEHSILS: "tehsils",
		CITIES: "cities",
		UNION_COUNCEL: "unionCouncils",
		COURSE_STREAM: "course-stream",
		COURSE_LEVEL: "course-level",
		COURSE_NOTIFYING_AUTHORITY: "course-notifying-authority",
		COURSES: "courses",
		COURSE_DETAILS: "courseDetails",
		SECTOR: "sector",
		APPLICATIONS_PENDING: "applications-pending",
		APPLICATIONS_SCRUTINIZED: "applications-scrutinized",
		APPLICATIONS_INSPECTED: "applications-inspected",
		APPLICATIONS_REJECTED: "applications-rejected",
		APPLICATIONS_APPROVED: "applications-approved",
		PENDING_CERTIFICATES: "pending-certificates",
		COMMITTEE_APPROVAL_PENDING: "committee-approval-pending",
		COMMITTEE_APPROVED: "committee-approved",
		COMMITTEE_REJECTED: "committee-rejected",
		COMMITTEE_FINALIZED: "committee-finalized",
		INSPECTION_TYPES: "inspection-types",
		INSPECTION_APPLICATIONS: "inspection-applications",
		INSPECTION_STATS: "inspection-stats",
		COMMITTEE_MEMBERS: "committee-members",
		DASHBOARD_STATS: "dashboard-stats",
		DASHBOARD_PIE_STATS: "dashboard-pie-stats",
		DASHBOARD_BAR_STATS: "dashboard-bar-stats",
		APPLICATION_SESSIONS: "application-sessions",
		APPLICATION_TYPES: "application-types",
		ORGANIZATION_TYPE: "organization-type",
		APPLICATION_PREDICTION: "application-prediction",
		ACADEMIC_CALENDARS: "academic-calendars",
		TRADE_SESSIONS: "trade-sessions",
		CERTIFIED_INSTITUTES: "certified-institutes",
		ALL_TRADES: "all-trades",
		SESSION_STATUSES: "session-statuses",
		PRIORITIES: "priorities",
		EVENT_TYPES: "event-types",
		APPLIES_TO: "applies-to",
		CALENDAR_EVENTS: "calendar-events",
		CALENDAR_EVENT_DETAILS: "calendar-event-details",
	},
	CERTIFICATES: {
		GET_CERTIFICATES: "certificates",
		DETAILS: "certificate-details",
		DOWNLOAD: "certificate-download",
	},
	MEMBERS: {
		DETAILS: "member-details",
		STATUS: "member-status",
		COMMITTEE_MEMBER_DETAILS: "committee-member-details",
		ACTIVATE_MEMBER: "activate-member",
		DEACTIVATE_MEMBER: "deactivate-member",
	},
	REPORTS: {
		OVERVIEW_STATS: "overview-stats",
		ATTENDANCE_STATS: "attendance-stats",
		GENDER_DISTRIBUTION: "gender-distribution",
		TRADE_WISE_COMPARISON: "trade-wise-comparison",
		ENROLLMENT_TRENDS: "enrollment-trends",
		DAILY_ATTENDANCE_TREND: "daily-attendance-trend",
		KPI_STATS: "kpi-stats",
		KPI_PERFORMANCE: "kpi-performance",
		ANALYTIC_STATS: "analytic-stats",
		SECTORWISE_JOB_PLACEMENT: "sectorwise-job-placement",
		TRADE_WISE_APPLICATION: "trade-wise-application",
		PROJECT_PERFORMANCE: "project-performance",
		RISK_ASSESSMENT: "risk-assessment",
		COMPONENT_PROGRESS: "component-progress",
	},
	APPLICATIONS: "applications",
	ATTENDANCE: "attendance",
};
export const QUERY_PARAMS = {};

export const AUTH_ENDPOINTS = [
	SERVER_ROUTES.AUTH.SIGN_IN,
	SERVER_ROUTES.AUTH.SIGN_UP,
	SERVER_ROUTES.AUTH.FORGOT_PASSWORD,
	SERVER_ROUTES.AUTH.RESET_PASSWORD,
	SERVER_ROUTES.AUTH.VERIFY_OTP,
	SERVER_ROUTES.AUTH.RESEND_OTP,
	SERVER_ROUTES.AUTH.VERIFY_EMAIL,
];
